import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import {
  DesktopDatePicker,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import Layout from "./Layout";
import AdapterJalali from "@date-io/date-fns-jalali";
import { isMobile } from "react-device-detect";
import { useFormik } from "formik";
import { getDefaultPerson, Person } from "../models/Person";

import { EDUCATION_OPTIONS } from "../constants/Education";
import Head from "./Head";
import { getCities, getStates } from "../constants/StatesAndCities";
import { validationSchema } from "./ValidationSchema";
import { toastError, toastWarning } from "../shared";
import SuccessDialog from "./SuccessDialog";
import { useState } from "react";
import { MESSANGERS_OPTIONS } from "../constants/Messanger";

export default function Page() {
  const [open, setOpen] = useState(false);
  const formik = useFormik<Person>({
    initialValues: getDefaultPerson(),
    validationSchema: validationSchema,
    isInitialValid: false,
    onSubmit: async (values) => {
      let v = {
        ...values,
        salavat_num: values.salavat_num ?? 1,
        birthdate: new Date(values.birthdate).toLocaleDateString("fa-IR"),
      };
      const res = await fetch("/django/", {
        method: "POST",
        body: JSON.stringify(v),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      if (res.status == 200) {
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          window.location.reload();
        }, 5000);
        formik.resetForm();
      } else {
        toastError("مشکلی پیش آمده ");
      }
    },
  });
  return (
    <>
      <SuccessDialog open={open} />
      <Layout>
        <Head />
        <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <div className="flex justify-center items-start flex-nowrap">
            <div
              id="container"
              className=" flex-[100%] md:flex-[80%] max-h-[calc(100vh-168px)]  overflow-y-scroll"
            >
              <div className="gridStyle">
                <TextField
                  variant="outlined"
                  id="f_name"
                  autoFocus={true}
                  name="f_name"
                  label="نام *"
                  value={formik.values.f_name}
                  onChange={formik.handleChange}
                  error={formik.touched.f_name && Boolean(formik.errors.f_name)}
                  helperText={
                    formik.errors.f_name &&
                    formik.touched.f_name &&
                    formik.errors.f_name
                  }
                />
                <TextField
                  variant="outlined"
                  id="l_name"
                  name="l_name"
                  label="نام خانوادگی *"
                  value={formik.values.l_name}
                  onChange={formik.handleChange}
                  error={formik.touched.l_name && Boolean(formik.errors.l_name)}
                  helperText={
                    formik.errors.l_name &&
                    formik.touched.l_name &&
                    formik.errors.l_name
                  }
                />
                <LocalizationProvider dateAdapter={AdapterJalali}>
                  {isMobile ? (
                    <MobileDatePicker
                      label="تاریخ تولد *"
                      value={formik.values.birthdate}
                      onChange={(val) => formik.setFieldValue("birthdate", val)}
                      renderInput={(params) => (
                        <TextField
                          id="birthdate"
                          name="birthdate"
                          label="تاریخ تولد *"
                          value={formik.values.birthdate}
                          onChange={(val) =>
                            formik.setFieldValue("birthdate", val)
                          }
                          error={
                            formik.touched.birthdate &&
                            Boolean(formik.errors.birthdate)
                          }
                          helperText={
                            formik.errors.birthdate &&
                            formik.touched.birthdate &&
                            formik.errors.birthdate
                          }
                          {...params}
                        />
                      )}
                    />
                  ) : (
                    <DesktopDatePicker
                      label="تاریخ تولد *"
                      value={formik.values.birthdate}
                      onChange={(val) => formik.setFieldValue("birthdate", val)}
                      renderInput={(params) => (
                        <TextField
                          id="birthdate"
                          name="birthdate"
                          type="date"
                          label="تاریخ تولد *"
                          value={formik.values.birthdate}
                          onChange={(val) =>
                            formik.setFieldValue("birthdate", val)
                          }
                          error={
                            formik.touched.birthdate &&
                            Boolean(formik.errors.birthdate)
                          }
                          helperText={
                            formik.errors.birthdate &&
                            formik.touched.birthdate &&
                            formik.errors.birthdate
                          }
                          {...params}
                        />
                      )}
                    />
                  )}
                </LocalizationProvider>
                <FormControl
                  variant="outlined"
                  fullWidth
                  error={
                    !!(
                      formik.errors.education &&
                      formik.touched.education &&
                      formik.errors.education
                    )
                  }
                >
                  <InputLabel id="education">سطح تحصیلات *</InputLabel>
                  <Select
                    labelId="education"
                    label="سطح تحصیلات *"
                    id="education"
                    name="education"
                    value={formik.values.education}
                    onChange={(e) =>
                      formik.setFieldValue(e.target.name, e.target.value)
                    }
                    error={
                      formik.touched.education &&
                      Boolean(formik.errors.education)
                    }
                  >
                    {EDUCATION_OPTIONS.map((v) => (
                      <MenuItem key={"education" + v.value} value={v.value}>
                        {v.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formik.errors.education &&
                      formik.touched.education &&
                      formik.errors.education}
                  </FormHelperText>
                </FormControl>
                <TextField
                  variant="outlined"
                  id="job"
                  name="job"
                  label="شغل"
                  value={formik.values.job}
                  onChange={formik.handleChange}
                  error={formik.touched.job && Boolean(formik.errors.job)}
                  helperText={
                    formik.errors.job && formik.touched.job && formik.errors.job
                  }
                />
                <FormControl
                  variant="outlined"
                  fullWidth
                  error={
                    !!(
                      formik.errors.sex &&
                      formik.touched.sex &&
                      formik.errors.sex
                    )
                  }
                >
                  <FormLabel id="sex-radio-buttons-group-label">
                    جنسیت *
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="sex-radio-buttons-group-label"
                    id="sex"
                    name="sex"
                    value={formik.values.sex}
                    onChange={formik.handleChange}
                  >
                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="مرد"
                    />
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="زن"
                    />
                  </RadioGroup>
                  <FormHelperText>
                    {formik.errors.sex &&
                      formik.touched.sex &&
                      formik.errors.sex}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  variant="outlined"
                  fullWidth
                  error={
                    !!(
                      formik.errors.marital_status &&
                      formik.touched.marital_status &&
                      formik.errors.marital_status
                    )
                  }
                >
                  <FormLabel id="marital_status-radio-buttons-group-label">
                    وضعیت تاهل *
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="marital_status-radio-buttons-group-label"
                    id="marital_status"
                    name="marital_status"
                    value={formik.values.marital_status}
                    onChange={formik.handleChange}
                  >
                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="مجرد"
                    />
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="متاهل"
                    />
                  </RadioGroup>
                  <FormHelperText>
                    {formik.errors.marital_status &&
                      formik.touched.marital_status &&
                      formik.errors.marital_status}
                  </FormHelperText>
                </FormControl>
                <TextField
                  variant="outlined"
                  id="mobile"
                  name="mobile"
                  label="شماره موبایل *"
                  placeholder="09121112233"
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                  helperText={
                    formik.errors.mobile &&
                    formik.touched.mobile &&
                    formik.errors.mobile
                  }
                />
                <TextField
                  variant="outlined"
                  id="messenger_mobile"
                  name="messenger_mobile"
                  label="شماره پیامرسان"
                  placeholder="09121112233"
                  value={formik.values.messenger_mobile}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.messenger_mobile &&
                    Boolean(formik.errors.messenger_mobile)
                  }
                  helperText={
                    formik.errors.messenger_mobile &&
                    formik.touched.messenger_mobile &&
                    formik.errors.messenger_mobile
                  }
                />
                <FormControl
                  variant="outlined"
                  fullWidth
                  error={
                    !!(
                      formik.errors.message_receiving &&
                      formik.touched.message_receiving &&
                      formik.errors.message_receiving
                    )
                  }
                >
                  <InputLabel id="message_receiving">
                    نحوه دریافت پیام *
                  </InputLabel>
                  <Select
                    labelId="message_receiving"
                    label="نحوه دریافت پیام *"
                    id="message_receiving"
                    name="message_receiving"
                    value={formik.values.message_receiving}
                    onChange={(e) =>
                      formik.setFieldValue(e.target.name, e.target.value)
                    }
                    error={
                      formik.touched.message_receiving &&
                      Boolean(formik.errors.message_receiving)
                    }
                  >
                    {MESSANGERS_OPTIONS.map((v) => (
                      <MenuItem
                        key={"message_receiving" + v.value}
                        value={v.value}
                      >
                        {v.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formik.errors.message_receiving &&
                      formik.touched.message_receiving &&
                      formik.errors.message_receiving}
                  </FormHelperText>
                </FormControl>
                <TextField
                  variant="outlined"
                  id="introduction"
                  name="introduction"
                  label="نحوه آشنایی *"
                  placeholder="مثلا آقای فراهانی با مراسم..."
                  value={formik.values.introduction}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.introduction &&
                    Boolean(formik.errors.introduction)
                  }
                  helperText={
                    formik.errors.introduction &&
                    formik.touched.introduction &&
                    formik.errors.introduction
                  }
                />

                <FormControl variant="outlined" fullWidth>
                  <FormLabel id="do_advertising-radio-buttons-group-label">
                    در حد توان فرهنگ صلوات را گسترش میدهم
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="do_advertising-radio-buttons-group-label"
                    id="do_advertising"
                    name="do_advertising"
                    value={formik.values.do_advertising}
                    onChange={formik.handleChange}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="بله"
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="خیر"
                    />
                  </RadioGroup>
                </FormControl>
                <TextField
                  variant="outlined"
                  id="salavat_num"
                  name="salavat_num"
                  label="تعداد صلوات روزانه *"
                  placeholder="حداقل 1"
                  type="number"
                  value={formik.values.salavat_num}
                  onChange={(e) =>
                    +e.target.value < 1
                      ? formik.setFieldValue(e.target.name, 1)
                      : formik.setFieldValue(e.target.name, e.target.value)
                  }
                  error={
                    formik.touched.salavat_num &&
                    Boolean(formik.errors.salavat_num)
                  }
                  helperText={
                    formik.errors.salavat_num &&
                    formik.touched.salavat_num &&
                    formik.errors.salavat_num
                  }
                />

                <FormControl variant="outlined" fullWidth>
                  <FormLabel id="team_leader-radio-buttons-group-label">
                    تمایل به سرگروه شدن دارم
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="team_leader-radio-buttons-group-label"
                    id="team_leader"
                    name="team_leader"
                    value={formik.values.team_leader}
                    onChange={formik.handleChange}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="بله"
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="خیر"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="divider !m-0 !p-0">
                لطفا مشخصات محل سکونت خود را وارد کنید
              </div>
              <div className="gridStyle">
                <FormControl
                  variant="outlined"
                  fullWidth
                  error={
                    !!(
                      formik.errors.state &&
                      formik.touched.state &&
                      formik.errors.state
                    )
                  }
                >
                  <InputLabel id="state">استان *</InputLabel>
                  <Select
                    labelId="state"
                    label="استان *"
                    id="state"
                    name="state"
                    value={formik.values.state}
                    onChange={(e) => {
                      formik.setFieldValue(e.target.name, e.target.value);
                      formik.setFieldValue("city", "");
                    }}
                    error={formik.touched.state && Boolean(formik.errors.state)}
                  >
                    {getStates().map((v) => (
                      <MenuItem key={"state" + v.value} value={v.value}>
                        {v.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formik.errors.state &&
                      formik.touched.state &&
                      formik.errors.state}
                  </FormHelperText>
                </FormControl>
                <FormControl
                  variant="outlined"
                  fullWidth
                  error={
                    !!(
                      formik.errors.city &&
                      formik.touched.city &&
                      formik.errors.city
                    )
                  }
                >
                  <InputLabel id="city">شهر *</InputLabel>
                  <Select
                    labelId="city"
                    label="شهر *"
                    id="city"
                    name="city"
                    value={formik.values.city}
                    onChange={(e) =>
                      formik.setFieldValue(e.target.name, e.target.value)
                    }
                    error={formik.touched.city && Boolean(formik.errors.city)}
                  >
                    {getCities(formik.values.state ?? "تهران").map((v) => (
                      <MenuItem key={"city" + v.value} value={v.value}>
                        {v.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formik.errors.city &&
                      formik.touched.city &&
                      formik.errors.city}
                  </FormHelperText>
                </FormControl>
                <TextField
                  variant="outlined"
                  id="neighborhood"
                  name="neighborhood"
                  label="نام محله *"
                  placeholder="مثل نارمک"
                  value={formik.values.neighborhood}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.neighborhood &&
                    Boolean(formik.errors.neighborhood)
                  }
                  helperText={
                    formik.errors.neighborhood &&
                    formik.touched.neighborhood &&
                    formik.errors.neighborhood
                  }
                />
                <TextField
                  variant="outlined"
                  id="region_num"
                  name="region_num"
                  label="شماره منطقه"
                  value={formik.values.region_num}
                  onChange={formik.handleChange}
                />
                <TextField
                  className="md:col-span-2 lg:col-span-4"
                  variant="outlined"
                  id="exact_address"
                  name="exact_address"
                  label="ادامه آدرس"
                  value={formik.values.exact_address}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="divider !m-0 !p-0 break-words">
                در موارد زیر به عنوان همیار
                <br className="md:hidden" /> با بنیاد صلوات همراهی میکنم
              </div>
              <div className="gridStyle !grid-cols-1 !md:grid-cols-1 !lg:grid-cols-1">
                <FormControl component="fieldset" variant="outlined">
                  <FormLabel component="legend">اجرائیات</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_1"
                          name="hamyari_1"
                          checked={formik.values.hamyari_1}
                          onChange={formik.handleChange}
                        />
                      }
                      label="حمل و نقل"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_2"
                          name="hamyari_2"
                          checked={formik.values.hamyari_2}
                          onChange={formik.handleChange}
                        />
                      }
                      label="مراسمات"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_3"
                          name="hamyari_3"
                          checked={formik.values.hamyari_3}
                          onChange={formik.handleChange}
                        />
                      }
                      label="نیروی اجرایی"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_4"
                          name="hamyari_4"
                          checked={formik.values.hamyari_4}
                          onChange={formik.handleChange}
                        />
                      }
                      label="مهارت فنی"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_5"
                          name="hamyari_5"
                          checked={formik.values.hamyari_5}
                          onChange={formik.handleChange}
                        />
                      }
                      label="آشپزی"
                    />
                  </FormGroup>
                </FormControl>
                <FormControl component="fieldset" variant="outlined">
                  <FormLabel component="legend">فرهنگی</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_6"
                          name="hamyari_6"
                          checked={formik.values.hamyari_6}
                          onChange={formik.handleChange}
                        />
                      }
                      label="مربی کودکان"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_7"
                          name="hamyari_7"
                          checked={formik.values.hamyari_7}
                          onChange={formik.handleChange}
                        />
                      }
                      label="فعالیت قرآنی"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_8"
                          name="hamyari_8"
                          checked={formik.values.hamyari_8}
                          onChange={formik.handleChange}
                        />
                      }
                      label="تربیتی"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_9"
                          name="hamyari_9"
                          checked={formik.values.hamyari_9}
                          onChange={formik.handleChange}
                        />
                      }
                      label="آموزش و تدریس"
                    />
                  </FormGroup>
                </FormControl>
                <FormControl component="fieldset" variant="outlined">
                  <FormLabel component="legend">اقتصادی</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_10"
                          name="hamyari_10"
                          checked={formik.values.hamyari_10}
                          onChange={formik.handleChange}
                        />
                      }
                      label="کارآفرینی"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_11"
                          name="hamyari_11"
                          checked={formik.values.hamyari_11}
                          onChange={formik.handleChange}
                        />
                      }
                      label="محیط و فضا"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_12"
                          name="hamyari_12"
                          checked={formik.values.hamyari_12}
                          onChange={formik.handleChange}
                        />
                      }
                      label="مالی"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_13"
                          name="hamyari_13"
                          checked={formik.values.hamyari_13}
                          onChange={formik.handleChange}
                        />
                      }
                      label="اعتباری"
                    />
                  </FormGroup>
                </FormControl>
                <FormControl component="fieldset" variant="outlined">
                  <FormLabel component="legend">هنر و رسانه</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_14"
                          name="hamyari_14"
                          checked={formik.values.hamyari_14}
                          onChange={formik.handleChange}
                        />
                      }
                      label="گرافیک و تدوین"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_15"
                          name="hamyari_15"
                          checked={formik.values.hamyari_15}
                          onChange={formik.handleChange}
                        />
                      }
                      label="رسانه"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_16"
                          name="hamyari_16"
                          checked={formik.values.hamyari_16}
                          onChange={formik.handleChange}
                        />
                      }
                      label="هنر"
                    />
                  </FormGroup>
                </FormControl>
                <FormControl component="fieldset" variant="outlined">
                  <FormLabel component="legend">سلامت</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_17"
                          name="hamyari_17"
                          checked={formik.values.hamyari_17}
                          onChange={formik.handleChange}
                        />
                      }
                      label="بهداشت و درمان"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_18"
                          name="hamyari_18"
                          checked={formik.values.hamyari_18}
                          onChange={formik.handleChange}
                        />
                      }
                      label="مشاوره خانواده و روانشناسی"
                    />
                  </FormGroup>
                </FormControl>
                <FormControl component="fieldset" variant="outlined">
                  <FormLabel component="legend">سایر</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_19"
                          name="hamyari_19"
                          checked={formik.values.hamyari_19}
                          onChange={formik.handleChange}
                        />
                      }
                      label="پژوهشی"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="hamyari_20"
                          name="hamyari_20"
                          checked={formik.values.hamyari_20}
                          onChange={formik.handleChange}
                        />
                      }
                      label="سایر همیاری ها"
                    />
                  </FormGroup>
                </FormControl>
              </div>
              <div className="divider !m-0 !p-0 mb-4">توضیحات تکمیلی</div>
              <div className="gridStyle !grid-cols-1 !md:grid-cols-1 !lg:grid-cols-1">
                <TextField
                  fullWidth
                  variant="outlined"
                  id="explain"
                  name="explain"
                  label=""
                  placeholder="توضیحات تکمیلی و دیگر مواردی همچون همیاری و یا تخصص خود را وارد نمایید"
                  value={formik.values.explain}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.explain && Boolean(formik.errors.explain)
                  }
                  helperText={
                    formik.errors.explain &&
                    formik.touched.explain &&
                    formik.errors.explain
                  }
                  multiline
                  rows={4}
                />
              </div>
              <div className="w-full p-4">
                <Button
                  color="success"
                  variant="contained"
                  className="h-14"
                  fullWidth
                  type="submit"
                  onClick={() => {
                    formik.setTouched({ f_name: true }, true).then(() => {
                      if (!formik.isValid) {
                        toastWarning("لطفا اطلاعات اجباری را کامل کنید");
                        let keys = Object.keys(formik.errors);
                        if (keys.length > 0) {
                          const selector = `[name=${keys[0]}]`;
                          const errorElement = document.querySelector(
                            selector
                          ) as HTMLElement;
                          if (errorElement) {
                            errorElement.scrollIntoView({
                              behavior: "smooth",
                              block: "center",
                            });
                            errorElement.focus({ preventScroll: true });
                          }
                        }
                      }
                    });
                  }}
                >
                  ثبت نام
                </Button>
                <span className="block w-full h-2"></span>
                <Button
                  color="secondary"
                  variant="contained"
                  fullWidth
                  type="reset"
                >
                  پاک کردن فرم
                </Button>
              </div>
            </div>
            <div className="hidden lg:block h-screen lg:flex-[20%] bgMasjed"></div>
          </div>
        </form>
      </Layout>
    </>
  );
}
